import { Component } from '@angular/core';
import { AdminSuppliersBulkActionsService, BulkActionType } from './bulk-actions.service';

@Component({
    selector: 'admin-suppliers-bulk-actions',
    template: `
        <admin-suppliers-bulk-eligibility
            *ngIf="
                (bulkActionType$ | async) === bulkActionType.EnableEligibility ||
                (bulkActionType$ | async) === bulkActionType.DisableEligibility
            "
            [enable]="(bulkActionType$ | async) === bulkActionType.EnableEligibility"
        ></admin-suppliers-bulk-eligibility>
        <admin-suppliers-bulk-enable-scf
            *ngIf="
                (bulkActionType$ | async) === bulkActionType.EnableSCF ||
                (bulkActionType$ | async) === bulkActionType.DisableSCF
            "
            [enable]="(bulkActionType$ | async) === bulkActionType.EnableSCF"
        ></admin-suppliers-bulk-enable-scf>

        <admin-suppliers-bulk-fee
            *ngIf="(bulkActionType$ | async) === bulkActionType.SetFeeStructure"
        ></admin-suppliers-bulk-fee>

        <admin-supplier-bulk-enrollment-invite
            *ngIf="(bulkActionType$ | async) === bulkActionType.SendEnrollmentInvite"
        ></admin-supplier-bulk-enrollment-invite>
    `
})
export class AdminSuppliersBulkActionsComponent {
    public bulkActionType$ = this._adminSuppliersBulkActionsService.bulkActionType$;

    public readonly bulkActionType = BulkActionType;

    constructor(private _adminSuppliersBulkActionsService: AdminSuppliersBulkActionsService) {}
}
